import { setGlobalCsrfToken } from '@/core/providers/CsrfProvider';

export function hasCsrfCookie(): boolean {
  return /(?:^|; )csrf-token=([^;]+)/.test(document.cookie || '');
}

export function extractCsrfTokenFromResponse(result: unknown): string | undefined {
  const response = result as Record<string, unknown>;
  return (
    (typeof response.csrfToken === 'string' && response.csrfToken) ||
    (typeof response.csrf_token === 'string' && response.csrf_token) ||
    (typeof response.token === 'string' && response.token) ||
    undefined
  );
}

export function cacheCsrfTokenForOnboarding(token: string | undefined): void {
  if (!token) return;
  setGlobalCsrfToken(token);

  try {
    let meta = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'csrf-token';
      document.head.appendChild(meta);
    }
    meta.content = token;
  } catch {
    // Non-critical: this is a compatibility path for clients reading meta tags.
  }
}
